import * as React from "react";
const SvgFiRrBaguette = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-baguette_svg__a)">
      <path
        fill="#062147"
        d="M23.036.964C21.842-.23 19.681-.32 16.947.71c-2.464.929-5.098 2.683-7.228 4.812L5.522 9.718c-2.13 2.13-3.884 4.765-4.813 7.228-1.03 2.733-.94 4.896.254 6.09.644.644 1.567.967 2.711.967.98 0 2.118-.237 3.378-.713 2.464-.929 5.098-2.683 7.228-4.812l4.197-4.196c2.13-2.13 3.884-4.765 4.813-7.228 1.03-2.733.94-4.896-.254-6.09M21.42 6.348c-.833 2.207-2.42 4.584-4.356 6.52l-4.197 4.196C10.93 19 8.554 20.587 6.347 21.419c-1.84.693-3.399.771-3.97.203-.57-.571-.49-2.129.203-3.97.456-1.208 1.143-2.464 1.984-3.674l2.728 2.728a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414L5.794 12.38c.365-.43.744-.85 1.142-1.248l1.391-1.391 2.965 2.965a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414L9.741 8.327l1.391-1.391c.398-.398.818-.777 1.248-1.141l2.912 2.912a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414l-2.728-2.728c1.21-.841 2.466-1.529 3.673-1.984 1.023-.386 1.96-.582 2.686-.582.582 0 1.03.126 1.284.379.571.571.491 2.129-.203 3.97z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-baguette_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBaguette;
